import React from 'react'
import Styles from '../../../BlogMetadata.module.scss'
import { PenEdit } from 'blaze-ui/icons/16/PenEdit'
import { LineSkeleton } from 'components/Skeleton/LineSkeleton'
import { AddImage } from 'almanac-ui/icons/16/AddImage'

interface FeaturedImageProps {
  featuredImageUrl: string
  featuredImageAltText: string
  imageLoading: boolean
  imageError: boolean
  setImageLoading: (loading: boolean) => void
  setImageError: (error: boolean) => void
  handleOpenFeaturedMediaModal: () => void
  handleDirectUpload: () => void
  hasExistingImages: boolean
}

export const FeaturedMediaImage: React.FC<FeaturedImageProps> = ({
  featuredImageUrl,
  featuredImageAltText,
  imageLoading,
  imageError,
  setImageLoading,
  setImageError,
  handleOpenFeaturedMediaModal,
  handleDirectUpload,
  hasExistingImages,
}) => {
  const handlePlaceholderClick = () => {
    if (hasExistingImages) {
      handleOpenFeaturedMediaModal()
    } else {
      handleDirectUpload()
    }
  }

  return (
    <>
      <label className={Styles.textFieldLabel}>Featured Image</label>
      {featuredImageUrl ? (
        <div className={Styles.featuredImageContainer} aria-busy={imageLoading}>
          <button
            type="button"
            className={Styles.featuredImageEditButton}
            aria-label="Change featured image"
            onClick={handleOpenFeaturedMediaModal}
          >
            <PenEdit size={18} color="var(--dark-80)" />
          </button>
          {imageLoading && !imageError && <LineSkeleton width="100%" className={Styles.featuredImageSkeleton} />}
          {!imageError ? (
            <img
              src={featuredImageUrl}
              alt={featuredImageAltText}
              className={Styles.featuredImage}
              style={{ display: imageLoading ? 'none' : 'block' }}
              onLoad={() => setImageLoading(false)}
              onError={() => {
                setImageLoading(false)
                setImageError(true)
              }}
            />
          ) : (
            <div className={Styles.featuredImageFallback}>
              <span>Image failed to load</span>
            </div>
          )}
        </div>
      ) : (
        <button
          type="button"
          className={Styles.featuredImagePlaceholder}
          aria-label="Add featured image"
          onClick={handlePlaceholderClick}
        >
          <AddImage size={32} color="#2196F3" />
          <span className={Styles.placeholderText}>Add Image</span>
        </button>
      )}
    </>
  )
}
